import { FunctionalComponent, h } from '@stencil/core';
import { FundDataPoints } from '../../../_interfaces/fund-card/fund-data-points';
import { dataWithChevron } from './_helpers';

interface NavProps {
	flag: boolean;
	dataPointValues: FundDataPoints;
	Tooltip: string;
}

export const Nav: FunctionalComponent<NavProps> = ({
	flag,
	dataPointValues,
	Tooltip,
}) => {
	if (flag)
		return (
			<div class="ds-data-points">
				{dataPointValues.general ? (
					<div class="ds-left-col">
						<div class="ds-body-s">
							{dataPointValues.label}&nbsp;
							<Tooltip content={dataPointValues.tooltip.first}></Tooltip>
						</div>
						<div class="ds-fund-data">{dataPointValues.data}</div>
					</div>
				) : null}

				{dataPointValues.secondaryGeneral ? (
					<div class="ds-right-col">
						<div class="ds-body-s">
							{dataPointValues.secondaryLabel}&nbsp;
							{dataPointValues.secondaryTooltip ? (
								<Tooltip
									content={`${dataPointValues.secondaryTooltip.first}<br>${dataPointValues.secondaryTooltip.second}`}
								></Tooltip>
							) : null}
						</div>
						{dataWithChevron(dataPointValues.secondaryData)}
					</div>
				) : null}
			</div>
		);
};
